import i18n from "../../../i18n";
import { BOOLEAN_FIELD_TYPE, NUMERIC_FIELD_TYPE, TEXT_FIELD_TYPE } from "../../../helpers/constants";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SelectFieldService from "../../../services/selectFieldService";

export const SURVEY_SCORE_TABLE_FIELDS_CONFIG = [
  {
    name: "hrscore_name",
    getValueCallback: (rowData) => rowData.hrscore_name,
    label: i18n.t("table.survey_score.score_name"),
    dataType: TEXT_FIELD_TYPE,
    editable: true,
    required: true,
  },
  {
    name: "hrscore_count",
    getValueCallback: (rowData) => rowData.hrscore_count,
    label: i18n.t("table.survey_score.numeric_value"),
    dataType: NUMERIC_FIELD_TYPE,
  },
  {
    name: "hrscore_is_for_calculation",
    getValueCallback: (rowData) =>
      SelectFieldService.getLabelOptionsTrueOrFalse(rowData.hrscore_is_for_calculation),
    label: i18n.t("table.survey_score.calculation"),
    dataType: TEXT_FIELD_TYPE,

  },
  {
    name: "delete",
    getValueCallback: (rowData, onDeleteScore, isReadOnly,index) =>
      !isReadOnly && (
        <DeleteOutlineIcon onClick={(e) => onDeleteScore(e, rowData.id,index)} />
      ),
    label: i18n.t("table.survey_score.delete"),
    dataType: null,
    editable: false,
  },
];

export const SURVEY_QUESTION_TABLE_FIELDS_CONFIG = [
  {
    name: "hrquestionkind_name",
    getValueCallback: (rowData) => rowData.hrquestionkind_name,
    label: i18n.t("table.survey_question.category"),
    dataType: TEXT_FIELD_TYPE,
    editable: false,
  },
  {
    name: "hrquestion_name",
    getValueCallback: (rowData) => rowData.hrquestion_name,
    label: i18n.t("table.survey_question.question"),
    dataType: TEXT_FIELD_TYPE,
    editable: false,
  },
  {
    name: "delete",
    getValueCallback: (rowData, onDeleteQuestion, isReadOnly, index) =>
      !isReadOnly && (
        <DeleteOutlineIcon onClick={(e) => onDeleteQuestion(e, rowData.id, index)} />
      ),
    label: i18n.t("table.survey_question.delete"),
    dataType: null,
    editable: false,
  },
];

export const HR_PARTICIPANT_TABLE_FIELDS_CONFIG = [
  {
    name: "participant",
    getValueCallback: (rowData) => rowData.full_name,
    label: i18n.t("table.hr_participant_table.participant"),
    dataType: TEXT_FIELD_TYPE,
  },
  {
    name: "hrrole_name",
    getValueCallback: (rowData) => rowData.hrrole_name,
    label: i18n.t("table.hr_participant_table.role"),
    dataType: TEXT_FIELD_TYPE,
  },
  {
    name: "self_evaluated",
    getValueCallback: (rowData) =>
      SelectFieldService.getLabelOptionsTrueOrFalse(rowData.self_evaluated),
    label: i18n.t("table.hr_participant_table.selfevaluated"),
    dataType: BOOLEAN_FIELD_TYPE,

  },
  {
    name: "delete",
    getValueCallback: (rowData, onDeleteParticipant, isReadOnly,index) =>
      !isReadOnly && (
        <DeleteOutlineIcon onClick={(e) => onDeleteParticipant(e, rowData.id, index)} />
      ),
    label: i18n.t("table.hr_participant_table.delete"),
    dataType: null,
    editable: false,
  },
];
